export const UproxxComExtractor = {
  domain: 'uproxx.com',

  title: {
    selectors: [
      'div.post-top h1',
    ],
  },

  author: {
    selectors: [
      '.post-top .authorname',
    ],
  },

  date_published: {
    selectors: [
       ['meta[name="article:published_time"]', 'value'],
    ],
  },

  lead_image_url: {
    selectors: [
      ['meta[name="og:image"]', 'value'],
    ],
  },

  content: {
    selectors: [
      '.post-body',
    ],

    // Is there anything in the content you selected that needs transformed
    // before it's consumable content? E.g., unusual lazy loaded images
    transforms: {
      'div.image': 'figure',
      'div.image .wp-media-credit': 'figcaption',
    },

    // Is there anything that is in the result that shouldn't be?
    // The clean selectors will remove anything that matches from
    // the result
    clean: [

    ],
  },
};
